package net.lateinit.bug_or_feature.site.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page

@Page("/q/{id}")
@Composable
fun PromptDetail() {
    Index()
}
